let session = null;

function cloneSession(data) {
  if (data == null) return null;
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return { ...data };
  }
}

export default {
  getSession() {
    return session ? cloneSession(session) : {};
  },

  setSession(data) {
    session = data == null ? null : cloneSession(data);
  },

  clear() {
    session = null;
  },
};
